// Lib
import { createSelector } from 'reselect';
import { uniq } from 'lodash/fp';

// Utils
import { getFirstSelectedBackgroundColor, getFirstSelectedColor } from './colorUtils';
import {
    getColorCssValue,
    getColorDefaultHexValue,
    getIsStandardColor,
} from '../../../../../common/colors/colorHelper';
import { isCard, isSketch } from '../../../../../common/elements/utils/elementTypeUtils';
import { getElementType } from '../../../../../common/elements/utils/elementPropertyUtils';
import { asObject } from '../../../../../common/utils/immutableHelper';

// Constants
import { DEFAULT_ELEMENT_COLOR } from '../../../../../common/colors/colorConstants';

export const colorToolSelector = createSelector(
    (state, ownProps) => ownProps.selectedElements,
    (state, ownProps) => ownProps.name,
    (selectedElements, name) => {
        const selectedColorName = getFirstSelectedColor(selectedElements);
        const selectedColor = getColorCssValue(selectedColorName);
        const selectedColorHex = getColorDefaultHexValue(selectedColor) || DEFAULT_ELEMENT_COLOR;

        const selectedBackgroundColorName = getFirstSelectedBackgroundColor(selectedElements);
        const selectedBackgroundColor = getColorCssValue(selectedBackgroundColorName);
        const selectedBackgroundColorHex = getColorDefaultHexValue(selectedBackgroundColor) || DEFAULT_ELEMENT_COLOR;

        const supportBackgroundColor = selectedElements.every((el) => isCard(el) || isSketch(el));
        const selectedTypes = uniq(asObject(selectedElements.map(getElementType)));

        return {
            name: selectedTypes.length > 1 ? 'Color' : name,
            elementType: getElementType(selectedElements?.first()),
            isStandardColor: getIsStandardColor(selectedColorName),
            supportBackgroundColor,
            selectedColor,
            selectedColorHex,
            selectedBackgroundColorName,
            selectedBackgroundColor,
            selectedBackgroundColorHex,
        };
    },
);
